<template>
  <section id="conhecimentos" class="skills-section">
    <div class="section-title">
      <h2 class="title">{{ $t('sections.skills') }}</h2>
    </div>

    <div class="container">
      <p>{{ $t('skills.intro') }}</p>
      <p>{{ $t('skills.practices') }}</p>
    </div>

    <div class="container skills-grid">
      <div
        v-for="group in skillGroups"
        :key="group.id"
        class="col"
      >
        <h3 class="section-subtitle">{{ pick(group.i18n).title }}</h3>

        <ul class="skills-list">
          <li
            v-for="skill in group.skills"
            :key="skill.id"
            class="conhecimento"
          >
            {{ pick(skill.i18n).name }}
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { useLocalized } from '@/composables/useLocalized';
import { skillGroups } from '@/data/skills';

const { pick } = useLocalized();
</script>

<style scoped lang="scss">
.skills-section {
  scroll-margin-top: 80px;
}

.skills-grid {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  @media (max-width: 768px) {
    flex-wrap: wrap;
  }

  .col {
    width: calc(100% / 3);
    padding: 15px;

    @media (max-width: 768px) {
      width: 100%;
    }
  }
}

.skills-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 30px;
}

.conhecimento {
  display: inline-flex;
  align-items: center;
  background: #1b1c1b;
  border: 1px solid #2c2c2c;
  border-radius: 999px;
  padding: 7px 14px;
  color: #fff;
  font-weight: 600;
  font-size: 15px;
  line-height: 1;
  white-space: nowrap;
}
</style>
